export const MESSAGES_INFO = {
  refundableFareNoPayment: {
    title: 'Ainda não há pagamentos',
    text: 'Os motoristas que pagaram a Taxa de Segurança Reembolsável nesse frete serão listados aqui',
  },
};
